module.exports = __webpack_public_path__ + "img/add_icon.8a9a40c3.png";